import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {BubbleList, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'type': 'primary',
                'ev-click': this.appendMessage,
                'children': '追加对话'
            }),
            _$ce(2, 'span', [
                _$ct('当前 '),
                this.get('items').length,
                _$ct(' 条消息')
            ], 0)
        ], 4, 'bubble-list-demo-append-actions'),
        _$cc(BubbleList, {
            'className': 'bubble-list-demo-append-list',
            'items': this.get('items'),
            'roles': this.get('roles')
        })
    ], 4, 'bubble-list-demo-append');
};